import { getFullLocale } from '../../../shared/utils/getFullLocale';
import { getMomentWithLocales } from '../../utils/momentLoader/getMoment';

export type IMoment = ReturnType<typeof momentFactory>;

/* @ngInject */
export function momentFactory($q: ng.IQService) {
  const fullLocale = getFullLocale();
  const shortLocale = window.__LOCALE__;
  return {
    getMoment: () => {
      return $q
        .resolve(getMomentWithLocales(fullLocale, shortLocale))
        .then(([moment, locale]) => {
          if (locale) {
            moment.locale(locale);
          }
          return moment;
        });
    },
  };
}
